import * as chains from "@paywithglide/glide-js/chains";

export const supportedChains = [
  chains.baseSepolia,
  chains.ethereumSepolia,
  chains.ethereum,
  chains.polygon,
  chains.arbitrum,
  chains.optimism,
  chains.base,
  chains.avalanche,
  chains.zksync,
  chains.fantom,
  chains.gnosis,
  chains.scroll,
  chains.polygonZkevm,
  chains.linea,
  chains.mantle,
  chains.zora,
  chains.blast,
  chains.taiko,
  chains.manta,
  chains.mode,
  chains.arbitrumNova,
  chains.boba,
  chains.bob,
  chains.cyber,
  chains.funkichain,
  chains.ham,
  chains.lisk,
  chains.mint,
  chains.rari,
  chains.redstone,
  chains.real,
  chains.solana,
  chains.sx,
  chains.sxToronto,
  chains.polygonAmoy,
  chains.solanaDevnet,
  chains.berachain,
  chains.ink,
  chains.bitcoin,
  chains.bitcoinTestnet,
  chains.tron,
  chains.tronShasta,
  chains.bsc,
  chains.paradex,
  chains.monad,
  chains.monadTestnet,
  chains.unichain,
  chains.hyperevm,
  chains.hypercore,
  chains.worldChain,
];
